import React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';
import {ReactComponent as HelpIcon} from '../../assets/icons/help-circle-gray.svg';
import {RoutePaths} from "../../config/routeConstants";
import {useTranslation} from "react-i18next";
import {Tooltip} from "@mui/material";

const HelpLink = styled(Link)`
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding: 8px 12px;
    border-radius: 20px;
    transition: all 0.2s ease;
    background: transparent;

    &:hover {
        background-color: #f5f5f5;
    }

    svg {
        height: 20px;
        width: 20px;
        color: rgba(29, 42, 65, 1);
        opacity: 0.8;
        transition: opacity 0.2s ease;
    }

    &:hover svg {
        opacity: 1;
    }
`;

const Manual: React.FC = () => {
    const {t} = useTranslation();
    return (
        <Tooltip title={t('sidebar.goToManual')}>
        <HelpLink to={`/${RoutePaths.Manual}`}>
            <HelpIcon/>
        </HelpLink>
        </Tooltip>
    );
};

export default Manual;
